import {createFeatureSelector, createSelector} from '@ngrx/store';
import {IStockSearchState} from './stock-search.reducer';

/**
 * Feature selector for stock search state.
 */
export const selectStockSearchState = createFeatureSelector<IStockSearchState>('stockSearch');

/**
 * Selector for stock search items (top 10).
 */
export const selectStockSearchItems = createSelector(
  selectStockSearchState,
  (state: IStockSearchState) => state.items.slice(0, 10),
);

/**
 * Selector for stock search loading state.
 */
export const selectStockSearchLoading = createSelector(
  selectStockSearchState,
  (state: IStockSearchState) => state.loading,
);

/**
 * Selector for stock search error.
 */
export const selectStockSearchError = createSelector(
  selectStockSearchState,
  (state: IStockSearchState) => state.error,
);

/**
 * Selector for advanced stock search data with pagination.
 */
export const selectStockSearchAdvancedData = createSelector(
  selectStockSearchState,
  (state: IStockSearchState) => state.advancedData,
);

/**
 * Selector for advanced stock search loading state.
 */
export const selectStockSearchAdvancedLoading = createSelector(
  selectStockSearchState,
  (state: IStockSearchState) => state.advancedLoading,
);

/**
 * Selector for current search query in advanced search.
 */
export const selectStockSearchCurrentQuery = createSelector(
  selectStockSearchState,
  (state: IStockSearchState) => state.currentQuery,
);

/**
 * Selector for current store in advanced search.
 */
export const selectStockSearchCurrentStore = createSelector(
  selectStockSearchState,
  (state: IStockSearchState) => state.currentStore,
);

/**
 * Selector for current filters in advanced search.
 */
export const selectStockSearchCurrentFilters = createSelector(
  selectStockSearchState,
  (state: IStockSearchState) => state.currentFilters,
);
